module.exports = __webpack_public_path__ + "img/Travel_one.75a4e09b.png";